// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ckmQ","content":"styles_content__1R8DJ","row":"styles_row__2sHFN","footer":"styles_footer__2FWne","phraseLength":"styles_phraseLength__3gVck"};